var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "modal", staticClass: "modal fade" }, [
    _c(
      "div",
      {
        staticClass: "modal-dialog modal-dialog-scrollable",
        class: _vm.modalSize,
        attrs: { role: "document" }
      },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.$t("kanban.assignedCards.modal.title")))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.dismiss.apply(null, arguments)
                  }
                }
              },
              [_vm._v("×")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              !_vm.cards.length
                ? _c("div", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("kanban.assignedCards.modal.noCardsAssigned")
                        ) +
                        "\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.cards, function(compound) {
                return _c("KanbanCard", {
                  key: compound.card.id,
                  attrs: {
                    state: _vm.state,
                    board: compound.board,
                    flow: compound.flow,
                    card: compound.card
                  },
                  on: {
                    reload: function($event) {
                      return _vm.$emit("reload")
                    },
                    openCard: function($event) {
                      _vm.dismiss()
                      _vm.$emit("openCard", $event)
                    }
                  }
                })
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              { staticClass: "btn btn-secondary", on: { click: _vm.dismiss } },
              [_vm._v(_vm._s(_vm.$t("btnClose")))]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }